import { render, staticRenderFns } from "./TextWithSeeMore.vue?vue&type=template&id=0bb7fc0c&scoped=true"
import script from "./TextWithSeeMore.vue?vue&type=script&lang=ts"
export * from "./TextWithSeeMore.vue?vue&type=script&lang=ts"
import style0 from "./TextWithSeeMore.vue?vue&type=style&index=0&id=0bb7fc0c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bb7fc0c",
  null
  
)

export default component.exports